import { FitToolAndSizeChartUI } from "./FitToolAndSizeChartUI";
import { StandardProps } from "../componentMap";

export function FitToolAndSizeChart({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  return (
    <FitToolAndSizeChartUI product={product} runtimeConfig={runtimeConfig} />
  );
}
